var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container text-center",staticStyle:{"margin-top":"2rem"}},[_c('p',[_vm._v("糟糕，您訪問的頁面不見了，去書架看看吧")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/app/shelf"}},[_c('button',{staticClass:"btn primary"},[_vm._v("我的書架")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }